import { api } from './api';

/** Starts a browser download of a same-origin API URL (GET with the session cookie). */
export function startDownload(url: string): void {
  const link = document.createElement('a');
  link.href = url;
  link.download = '';
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
}

/** Downloads the complete .eml of a message. */
export function downloadEml(messageId: string): void {
  startDownload(api.sourceDownloadUrl(messageId));
}
